$(document).ready(function () {
    const dropdownButton = document.querySelector('.dropdown-button-js')
    const dropdownOptions = document.querySelector('.dropdown-options-js')

    dropdownButton.addEventListener('click', () => {
        dropdownOptions.classList.toggle('open');
    })
});
